export const SET_ITEMS_VOUCHER_BY_FETCH = 'app/voucher/SET_ITEMS';
